import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const userStore = create(
  persist(
    (set, get) => ({
      uid: null,
      nickname: null,
      autoGenerated: true,
      token: null,
      setUid: (uid) => set({ uid }),
      setNickname: (nickname) => set({ nickname }),
      setAutoGenerated: (autoGenerated) => set({ autoGenerated }),
      setToken: (token) => set({ token }),
      clear: () => set({ uid: null, nickname: null, autoGenerated: true, token: null }),
    }),
    {
      name: "mips/user",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export default userStore;
